import axios,{ InternalAxiosRequestConfig }  from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || `https://yayako-api-tscq7doceq-ez.a.run.app`,
});

api.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const token = localStorage.getItem("token");

  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;

});

export default api;
